import React, { Component } from 'react';
import './PaperJs.scss';
import image2base64 from 'image-to-base64';
import paper, { Path, Point } from 'paper';
import Resources from '../assets/Resources';

class PaperJs extends Component{

  constructor() {
    super();
    this.state = {
      layers: [],
      path: null,
      canvasRef: null,
      image: Resources.x_ray
    };
  }

  componentWillMount() {
    window.addEventListener("resize", this.resize);
  }

  componentDidMount() {
    this.resize();
    this.draw();
    paper.setup(this.canvas);
    document.getElementById("Paper-canvas").addEventListener("click", this.onClickUp);
  }

  draw = () => {
    image2base64(this.state.image)
    .then(response => {
      let canvas = document.getElementById('Paper-canvas');
      let ctx = canvas.getContext('2d');
      let img = new Image();
      let re = /(?:\.([^.]+))?$/;
      let ext = re.exec(this.state.image)[1];

      img.src = `data:image/${ext};base64,${response}`;
      this.drawImageScaled(img, ctx);
    })
    .catch(error => {
      console.log(error);
    })
  }

  drawImageScaled = (img, ctx) => {
    var canvas = ctx.canvas ;
    var hRatio = canvas.width  / img.width    ;
    var vRatio =  canvas.height / img.height  ;
    var ratio  = Math.min ( hRatio, vRatio );
    var centerShift_x = ( canvas.width - img.width*ratio ) / 2;
    var centerShift_y = ( canvas.height - img.height*ratio ) / 2;  
    ctx.clearRect(0,0,canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width*ratio, img.height*ratio);  
  }

  resize = () => {
    let canvas = document.getElementById("Paper-canvas");
    let container = document.getElementById("Paper-canvas-container");
    let width = container.clientWidth;
    let height = container.clientHeight;

    canvas.width = width;
    canvas.height = height;
    this.draw();
    this.connectPoints();
  }

  onClickUp = (event) => {

    let temp_path = null;

    if (!this.state.path) {
      let initial_path = new Path(new Point(event.clientX , event.clientY));
      initial_path.strokeColor = 'black';
      initial_path.strokeWidth = 3;
      initial_path.selected = true;
      initial_path.selectedColor = 'blue';

      temp_path = initial_path;
    } else {
      temp_path = this.state.path.clone();
      let point = new Point(event.clientX , event.clientY);
      temp_path.add(point);
    }

    if (temp_path._segments.length >= 4) {
      temp_path.closed = true;
    }

    this.setState({
      path: temp_path
    }, () => {
      console.log(temp_path);
      this.connectPoints();
    })
  }

  connectPoints = () => {

    if (this.state.path) {
      let path = this.state.path.clone();

      path._segments.forEach((element, index) => {
        if(index>0) {
          let canvas = document.getElementById("Paper-canvas");
          let ctx = canvas.getContext("2d");
          ctx.beginPath();
          ctx.strokeStyle = 'white';
          ctx.strokeWidth = 6;
          ctx.moveTo(path._segments[index-1]._point._x - canvas.offsetLeft , path._segments[index-1]._point._y - canvas.offsetTop);
          ctx.lineTo(element._point._x - canvas.offsetLeft , element._point._y - canvas.offsetTop);
          ctx.stroke();
        }
      });
    }
  }

  render() {
    return(
      <div id="Paper-canvas-container" className="Paper-container">
        <canvas ref={this.canvas} id="Paper-canvas" ></canvas>
      </div>
    )
  }
};

export default PaperJs;